
import requestInstance from "./Request";
import { setCurrentUser } from "utils/utils";

let env = process.env.REACT_APP_B2B_API_BASE_URL;

export const requestBookingReportApi = async (data) => {
  const payload = {
    startDate: data?.startDate || "",
    endDate: data?.endDate || "",
    reportType: data?.reportType || "B2B_TRIP_REPORT",
    reportFormate: data?.reportFormate || "csv",
    filters: {
      ...data?.filters,
      isB2B: true
    }
  };

  const res = await requestInstance
    .post(`${env}/admin-api/v3/tasks/report`, payload)
    .catch((err) => err.response);
  return setCurrentUser(res);
};